import {LogoWithLabel} from '@shared/components/Logo/LogoWithLabel'
import {appUrl} from '../../../AppUrl'
import {trans} from '../../../helpers'
import {useRegionConfig} from '../../../hooks'
import {useScheduledEventLogoConfig} from '../../../hooks/useScheduledEventLogoConfig'

interface TopNavigationLogoProps {
    showLabel?: boolean
    short?: boolean
}

// Логотип в верхнем меню навигации.
// Иногда используется event лого вместо стандартного.
export function TopNavigationLogo(props: TopNavigationLogoProps) {

    const {
        showLabel = true,
        short = false,
    } = props

    const regionConfig = useRegionConfig()

    const url: string = appUrl().index
    const label: string = regionConfig.logoSubtitle
    const alt: string = trans().common.app_name
    const defaultLogo = (
        <LogoWithLabel
            url={url}
            label={showLabel ? label : null}
            alt={alt}
            short={short}
            className="top-nav-logo"
        />
    )

    // Логотип события.
    const showDefaultLogoTogetherWithEventLogo = false
    const eventLogoConfig = useScheduledEventLogoConfig(regionConfig.region)

    if (eventLogoConfig) {
        // Логотип события.
        return (
            <>
                <LogoWithLabel
                    url={url}
                    label={showLabel ? label : null}
                    alt={alt}
                    short={short}
                    className="top-nav-event-logo"
                    fullLogoUrl={eventLogoConfig.logoUrl}
                    fullLogoStyle={eventLogoConfig.logoStyle}
                    fullLogoWrapperStyle={eventLogoConfig.logoWrapperStyle}
                    logoLabelStyle={eventLogoConfig.logoLabelStyle}
                />
                {showDefaultLogoTogetherWithEventLogo && defaultLogo}
            </>
        )
    }

    return defaultLogo
}
